import { Buffer } from "buffer";

export function GetJwtClaim<TClaimType>(token: string | undefined, claim: string): TClaimType | undefined {
    if (!token) {
        return undefined;
    }

    try {
        let base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");

        var padding = (4 - (base64.length % 4)) % 4;
        base64 += "=".repeat(padding);

        const tokenJson = Buffer.from(base64, "base64").toString("utf-8");

        const jObject = JSON.parse(tokenJson);

        return (jObject[claim] as TClaimType) ?? undefined;
    } catch (error) {
        return undefined;
    }
}
